import { RoleDefinition } from '@/types/roleDefinition';

export const baseRoles: readonly RoleDefinition[] = [
  {
    value: 'ADMIN',
    name: 'Admin',
    description: 'ADMIN_DESCRIPTION',
  },
  {
    value: 'OPERATOR',
    name: 'OPERATOR',
    description: 'OPERATOR_DESCRIPTION',
  },
  {
    value: 'VIEWER',
    name: 'VIEWER',
    description: 'VIEWER_DESCRIPTION',
  },
];
